/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AddServiceCurrencyInput = {
    serviceID: string;
    currency: string;
    newPrices?: Array<NewCurrencyPriceInput> | null;
};
export type NewCurrencyPriceInput = {
    chargeID: string;
    price: number;
};
export type mutationsAddCurrencyMutationVariables = {
    input: AddServiceCurrencyInput;
};
export type mutationsAddCurrencyMutationResponse = {
    readonly addServiceCurrency: {
        readonly id: string;
    };
};
export type mutationsAddCurrencyMutation = {
    readonly response: mutationsAddCurrencyMutationResponse;
    readonly variables: mutationsAddCurrencyMutationVariables;
};



/*
mutation mutationsAddCurrencyMutation(
  $input: AddServiceCurrencyInput!
) {
  addServiceCurrency(input: $input) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "addServiceCurrency",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsAddCurrencyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsAddCurrencyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95bf3d41db3046fc08e722c95758154d",
    "id": null,
    "metadata": {},
    "name": "mutationsAddCurrencyMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsAddCurrencyMutation(\n  $input: AddServiceCurrencyInput!\n) {\n  addServiceCurrency(input: $input) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '67c766a5a81c12437f1eb2b9859d01ca';
export default node;
